import React from 'react';
import classNames from 'classnames';

const RecordingEmbed = ({ embedUrl, className }) => (
  <iframe
    title="Recording Embed"
    allowFullScreen
    width="100%"
    height="100%"
    allowtransparency="true"
    scrolling="no"
    style={{ backgroundColor: 'transparent' }}
    className={classNames('Video-iframe', className)}
    frameBorder="0"
    src={embedUrl}
  />
);

export default RecordingEmbed;
